<template>
    <div class="frame-container">
        <span role="button" @click="clicked(imageIndex)" class="pointer ml-2 frame-item" :class="selected === imageIndex ? 'frame-item-selected' : ''" v-for="(image, imageIndex) in images">
            <component :selected="selected === imageIndex" :is="image" :width="adjustSize(width, imageIndex)" :height="adjustSize(height, imageIndex)"></component>
        </span>
    </div>
</template>

<script>
    import Image1 from '@/components/Lab/Frame/1';
    import Image2 from '@/components/Lab/Frame/2';
    import Image3 from '@/components/Lab/Frame/3';
    import Image4 from '@/components/Lab/Frame/4';
    import Image5 from '@/components/Lab/Frame/5';
    import Image6 from '@/components/Lab/Frame/6';
    import Image7 from '@/components/Lab/Frame/7';
    import Image8 from '@/components/Lab/Frame/8';
    import {labMixin} from "@/mixins/lab";

    export default {
        name: "FrameSelect",
        props: {},
        mixins: [labMixin],
        components: {
            Image1, Image2, Image3, Image4, Image5, Image6, Image7, Image8
        },
        data() {
            return {
                numImages: 8
            }
        },
        computed: {},
        methods: {}
    }
</script>

<style lang="scss">
    svg {
        margin: 0;
    }

    .frame-container {
        display: flex;
        justify-content: space-around;
        align-items: center;
        margin: 10px 0;
        flex-wrap: wrap;
    }

    .frame-item {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 50px;
        width: 50px;
        //border: 1px solid #e3ebf6;
        &-selected {
            border: 2px solid #99d1ff;
            background: #cce8ff;
        }
        &:hover {
            background: #e5f3ff;
        }
    }

    .frame-stroke {
        stroke: #c1c1c1;
        stroke-width: 4;
        stroke-miterlimit: 10;
    }

    .fill-black {
        fill: #0d1b2b;
    }

    .frame-fill {
        fill: #ffffff;
        stroke: #ccc;
        stroke-width: 2;
    }

    .frame-fill:hover {
        stroke: #f6c343;
        stroke-width: 2;
        /* zoom: 10; */
    }

    .frame-active {
        //stroke: red;
        stroke-dasharray: 0;
    }
</style>
